import { Client } from '@microsoft/microsoft-graph-client';
import { API } from '../constants/api';

let officeClient = null;

class IntranetAuthProvider {
  static fetchAccessToken() {
    return fetch(`${API}/token`, { credentials: 'include' })
      .then(response => response.json())
      .then(json => json.access_token);
  }

  getAccessToken() {
    if (this.access_token) {
      return Promise.resolve(this.access_token);
    }
    return IntranetAuthProvider.fetchAccessToken().then(token => {
      this.access_token = token;
      return token;
    });
  }
}

export const createOfficeIntegration = () => {
  if (!officeClient) {
    const authProvider = new IntranetAuthProvider();
    const clientOptions = {
      authProvider
    };
    officeClient = Client.initWithMiddleware(clientOptions);
    window.officeClient = officeClient;
  }
};

export const getMe = () => officeClient.api('/me').get();

export const getUserDrives = () => officeClient.api('/me/drives').get();

export const getDepartmentDrives = department =>
  officeClient.api(`/groups/${department}/drives`).get();

export const getTeamDrive = teamId =>
  officeClient.api(`/groups/${teamId}/drive/`).get();

export const getTeamDriveFiles = (teamId, folderId = 'root') =>
  officeClient.api(`/groups/${teamId}/drive/items/${folderId}/children`).get();

export const getChats = () =>
  officeClient
    .api('/me/chats')
    .version('beta')
    .get();

export const getChatMembers = id =>
  officeClient
    .api(`/chats/${id}/members`)
    .version('beta')
    .select('id', 'displayName')
    .get();

export const getChatMessages = id =>
  officeClient
    .api(`/chats/${id}/messages`)
    .version('beta')
    .top(1)
    .get();

export const getMeDisplayName = () =>
  officeClient
    .api('/me')
    .select('displayName')
    .get();

export const getChatId = id =>
  officeClient
    .api(`/chats/${id}`)
    .version('beta')
    .get();

export const rootMessages = id =>
  officeClient
    .api(`/teams/${id}/messages`)
    .version('beta')
    .get();

export const getContactsByName = name =>
  officeClient
    .api('/me/people')
    .version('beta')
    .select('displayName,id')
    .search(`"${name}"`)
    .filter("mailboxType eq 'Mailbox'")
    .top(20)
    .get();

export const getMemberTeams = () => officeClient.api(`/me/joinedTeams`).get();

export const getInfoTeam = id => officeClient.api(`/teams/${id}`).get();
